import { render, staticRenderFns } from "./RoundedIconButton.vue?vue&type=template&id=0588fe14&scoped=true"
import script from "./RoundedIconButton.vue?vue&type=script&lang=js"
export * from "./RoundedIconButton.vue?vue&type=script&lang=js"
import style0 from "./RoundedIconButton.vue?vue&type=style&index=0&id=0588fe14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0588fe14",
  null
  
)

export default component.exports